import { callAPI } from "@/features/yard360/store/helpers/apiCaller";
import { APIS } from "@/app/app-config";
import { FETCH_PERMISSIONS, FETCH_PERMISSIONS_SUCCESS, FETCH_PERMISSIONS_FAILURE } from "./types";

export const fetchPermissions = () => {
  return async (dispatch, getState) => {
    dispatch({ type: FETCH_PERMISSIONS });

    try {
      const authInfo = getState().authInfo;
      const response = await callAPI(authInfo, APIS.GetRelayYardHubPermissions, {
        userContext: {
          accountId: authInfo.context?.accountId,
          userName: authInfo.context?.userName,
          userId: authInfo.context?.userId,
        },
      });

      dispatch({
        type: FETCH_PERMISSIONS_SUCCESS,
        payload: {
          agentStudio: {
            grantedPermissions: response?.agentStudio?.grantedPermissions ?? [],
          },
        },
      });
    } catch (e) {
      const message = e instanceof Error ? e.message : String(e);
      dispatch({
        type: FETCH_PERMISSIONS_FAILURE,
        payload: { error: message },
      });
    }
  };
};
